<template>
    <div class="essay-type-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-tickets"></i>
                    <span>作文类型管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="类型名称">
                    <el-input clearable v-model="query.typeName" placeholder="请输入类型名称" style="width: 160px"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 120px">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="primary" icon="el-icon-plus" @click="btnInsert(null)">新增类型</el-button>
                </div>
            </div>
            <el-table
                :data="list"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="100" align="center"/>
                <el-table-column prop="typeKey" label="类型标识" min-width="130">
                    <template slot-scope="scope">
                        <el-tag type="info" effect="plain" size="small">{{ scope.row.typeKey }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="typeName" label="类型名称" min-width="120" show-overflow-tooltip/>
                <el-table-column prop="structureTips" label="段落结构" min-width="220" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.structureTips || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="说明" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.description || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" width="80" align="center"/>
                <el-table-column prop="status" label="状态" align="center" width="80">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
                            {{ scope.row.status === 1 ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="170" align="center"/>
                <el-table-column align="center" label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-dropdown trigger="click" @command="(cmd) => handleCommand(cmd, scope.row)">
                            <el-button size="mini">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="edit" icon="el-icon-edit">编辑</el-dropdown-item>
                                <el-dropdown-item command="delete" icon="el-icon-delete">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="600px"
            class="essay-type-dialog">
            <el-form :model="formData" ref="formRef" :rules="rules" label-width="80px">
                <el-form-item label="类型标识" prop="typeKey">
                    <el-input v-model="formData.typeKey" maxlength="30" placeholder="英文标识，如：speech、letter"></el-input>
                </el-form-item>
                <el-form-item label="类型名称" prop="typeName">
                    <el-input v-model="formData.typeName" maxlength="20" placeholder="例如：发言稿"></el-input>
                </el-form-item>
                <el-form-item label="段落结构" prop="structureTips">
                    <el-input type="textarea" v-model="formData.structureTips" maxlength="500" placeholder="例如：开头问候→中间内容→结尾祝愿" :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="说明" prop="description">
                    <el-input type="textarea" v-model="formData.description" maxlength="200" placeholder="补充说明（可选）" :rows="2"></el-input>
                </el-form-item>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="排序" prop="sort">
                            <el-input-number v-model="formData.sort" :min="0" :max="9999" controls-position="right" style="width: 100%"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态" prop="status">
                            <el-radio-group v-model="formData.status">
                                <el-radio :label="1">启用</el-radio>
                                <el-radio :label="0">禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqTypePage, reqTypeAdd, reqTypeUpdate, reqTypeDelete } from '@/api/education/essay'

export default {
    name: 'EssayType',
    data() {
        return {
            list: [],
            total: 0,
            tableLoading: false,
            submitLoading: false,
            query: {
                currentPage: 1,
                pageSize: 10,
                typeName: '',
                status: null
            },
            dialogVisible: false,
            dialogTitle: '',
            formData: {
                id: null,
                typeKey: '',
                typeName: '',
                structureTips: '',
                description: '',
                sort: 0,
                status: 1
            },
            rules: {
                typeKey: [
                    { required: true, message: '请输入类型标识', trigger: 'blur' },
                    { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
                ],
                typeName: [
                    { required: true, message: '请输入类型名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.load()
    },
    methods: {
        async load() {
            this.tableLoading = true
            try {
                const data = await reqTypePage(this.query)
                this.list = data.records || []
                this.total = data.total || 0
            } catch (e) {
                this.$message.error('加载作文类型列表失败')
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                currentPage: 1,
                pageSize: 10,
                typeName: '',
                status: null
            }
            this.load()
        },
        handleCommand(command, row) {
            switch (command) {
                case 'edit':
                    this.btnInsert(row)
                    break
                case 'delete':
                    this.btnDelete(row.id)
                    break
            }
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        btnInsert(row) {
            if (row) {
                this.dialogTitle = '编辑类型'
                this.formData = {
                    id: row.id,
                    typeKey: row.typeKey || '',
                    typeName: row.typeName || '',
                    structureTips: row.structureTips || '',
                    description: row.description || '',
                    sort: row.sort || 0,
                    status: row.status != null ? row.status : 1
                }
            } else {
                this.dialogTitle = '新增类型'
                this.formData = {
                    id: null,
                    typeKey: '',
                    typeName: '',
                    structureTips: '',
                    description: '',
                    sort: 0,
                    status: 1
                }
            }
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate()
                }
            })
            this.dialogVisible = true
        },
        async btnDelete(id) {
            try {
                await this.$confirm('确定要删除该作文类型吗？删除后不可恢复。', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqTypeDelete(id)
                this.$message.success('删除成功')
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                }
            }
        },
        submitForm() {
            this.$refs.formRef.validate(async valid => {
                if (!valid) return

                this.submitLoading = true
                try {
                    if (this.formData.id) {
                        await reqTypeUpdate(this.formData)
                    } else {
                        await reqTypeAdd(this.formData)
                    }
                    this.$message.success('操作成功')
                    this.dialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.essay-type-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }
}

@media screen and (max-width: 768px) {
    .essay-type-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 16px;
        }

        ::v-deep .el-dialog__footer {
            padding: 12px 16px;
        }

        ::v-deep .el-pagination {
            white-space: normal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 4px;
        }

        ::v-deep .el-pagination .el-pagination__total,
        ::v-deep .el-pagination .el-pagination__sizes {
            margin-right: 0;
        }

        ::v-deep .el-pagination button,
        ::v-deep .el-pagination .el-pager li {
            min-width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
        }
    }
}
</style>
